// Import necessary Angular modules
import { Component, Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { NgStyle } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-litmus-footer', // Component selector
    templateUrl: './litmus-footer.component.html', // Template file
    styleUrls: ['./litmus-footer.component.scss'] // Styles file
    ,
    imports: [NgStyle, TranslateModule]
})
export class LitmusFooterComponent {
  @Input() isAccount; // Input property to receive data from parent component
  buildVersion = ''; // Variable to hold build version
  appVersion = environment.version;
  copyrightYear = new Date().getFullYear();
  copyrightText = `© ${this.copyrightYear} LitmusWorld | All Rights Reserved | Privacy Policy`;
  constructor(private http: HttpClient) {
    // Only fetch build version if not in local environment
    if (this.isProductionOrStaging()) {
      this.fetchBuildVersion();
    } else {
      // In local environment, use app version directly
      this.buildVersion = this.appVersion;
    }
  }

  /**
   * Checks if the current environment is production or staging
   * @returns {boolean} True if environment is production or staging
   */
  private isProductionOrStaging(): boolean {
    const hostname = window.location.hostname;
    return hostname.includes('staging') || hostname.includes('dashboard');
  }

  /**
   * Fetches build version from API
   * Only called in staging or production environments
   */
  fetchBuildVersion() {
    // this.buildVersion = this.appVersion;
    this.http.get('/v3/build_version').subscribe((data) => {
      if (data && data['build_version']) {
        // Set the fetched build version to the variable
        this.buildVersion = data['build_version'];
        if(this.buildVersion !== this.appVersion){
          console.log("A new update has been released. Please refresh the page to experience the latest improvements.")
        }
      }
    });
  }
}
